import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import { getRegion } from "@util/domain";
import Card from "@components/cards/Card/Card";
import Button from "@components/buttons/Button/Button";
import styles from "@styles/CommonAuthPageLayout.module.css";

const HomePage = () => {
    return (
        <>
            <Helmet>
                <title>Memorial Hub | Forever In Our Hearts</title>
                <meta
                    name="description"
                    content={`Manage your online memorials and tributes. Easily update, ${getRegion() === "global" ? "personalize" : "personalise"}, and share your loved one’s legacy pages with family and friends.`}
                />
            </Helmet>
            <Card className={styles.cardContainer}>
                <Button
                    variant="primary"
                    to="/auth/sign-in"
                >
                    Sign In
                </Button>
                <div className={styles.buttonLinkContainer}>
                    <Button
                        variant="primary"
                        to="/auth/sign-up"
                    >
                        Create Account
                    </Button>
                </div>
            </Card>
        </>
    );
};

export default HomePage;
